import OpeningHourModal from "./OpeningHourModal";
export default OpeningHourModal;